import React from 'react';
import { Check } from 'lucide-react';
import { instituteMock } from '../data/mock';

const Specializations = () => {
  const { specializations } = instituteMock;

  return (
    <section className="section-padding bg-secondary" id="specializations-section">
      <div className="container">
        <div className="grid-two-column">
          <div className="specialization-content">
            <h2 className="heading-1" style={{ marginBottom: '16px' }}>
              {specializations.title}
            </h2>
            <p className="body-large" style={{ marginBottom: '32px' }}>
              {specializations.description}
            </p>
            <ul className="specialization-list">
              {specializations.items.map((item, index) => (
                <li key={index} className="specialization-item">
                  <Check size={20} className="check-icon" />
                  <span className="body-regular">{item}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="specialization-image">
            <img 
              src={specializations.image} 
              alt="Especialização em retina" 
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Specializations;
